// API configuration
const isDevelopment = process.env.NODE_ENV === 'development';

export const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8080'
  : 'https://diylegalv2.onrender.com';

export const API_ENDPOINTS = {
  GENERATE_DOCUMENT: `${API_BASE_URL}/generate-document`,
  CONVERT_DOCX: `${API_BASE_URL}/convert-docx`,
  PROCESS_TEMPLATE: `${API_BASE_URL}/process-template`,
  PROCESS_CHUNK: `${API_BASE_URL}/process-chunk`,
  PROCESS_LETTERHEAD: `${API_BASE_URL}/process-letterhead`,
  DETECT_PLACEHOLDERS: `${API_BASE_URL}/detect-placeholders`,
} as const; 